// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  ViewChild,
  computed,
  input,
  output,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-ghost-button',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './ghost-button.html',
})
export class GhostButton {
  @ViewChild('button') public buttonRef: ElementRef<HTMLElement> | null = null;

  public label = input.required<string>();
  public type = input<'default' | 'danger'>('default');
  public iconLeft = input<string>();
  public iconRight = input<string>();
  public disabled = input<boolean>(false);
  public fullWidth = input<boolean>(false);
  public buttonClicked = output<boolean>();

  public buttonClasses = computed(() => {
    const classes: string[] = [
      'px-2xs',
      'py-3xs',
      'rounded-2xs',
      'flex',
      'items-center',
      'justify-center',
      'gap-2xs',
      'group',
    ];

    // Width handling
    if (this.fullWidth()) {
      classes.push('w-full');
    }

    // Default state
    if (!this.disabled()) {
      if (this.type() === 'default') {
        classes.push('text-grey-110', 'bg-transparent');
        // Hover state
        classes.push('hover:bg-grey-30');
        // Focus state
        classes.push(
          'focus:bg-white',
          'focus:shadow-[0px_0px_0px_3px_rgba(208,221,255,1)]',
        );
        // Pressed state
        classes.push('active:bg-grey-30', 'active:text-grey-120');
      } else if (this.type() === 'danger') {
        classes.push('text-red-110', 'bg-transparent');
        // Hover state
        classes.push('hover:bg-red-30');
        // Focus state
        classes.push(
          'focus:bg-white',
          'focus:shadow-[0px_0px_0px_3px_rgba(254,189,186,1)]',
        );
        // Pressed state
        classes.push('active:bg-red-30', 'active:text-red-120');
      }
    } else {
      // Disabled state
      classes.push('text-grey-80', 'bg-transparent', 'cursor-not-allowed');
    }

    return classes.join(' ');
  });

  public iconClasses = computed(() => {
    const classes: string[] = ['w-lg', 'h-lg'];

    if (this.disabled()) {
      classes.push('fill-grey-80');
    } else {
      if (this.type() === 'default') {
        classes.push('fill-grey-110', 'group-active:fill-grey-120');
      } else if (this.type() === 'danger') {
        classes.push('fill-red-110', 'group-active:fill-red-120');
      }
    }

    return classes.join(' ');
  });

  /**
   * Emits the click event
   */
  public submit(): void {
    if (!this.disabled()) {
      this.buttonRef?.nativeElement.blur();
      this.buttonClicked.emit(true);
    }
  }
}
